import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';

function AcaoGovernamentalModal({ show, onClose, onSave, data }) {
  const [codigo, setCodigo] = useState('');
  const [descricao, setDescricao] = useState('');
  const [saving, setSaving] = useState(false);
  const token = localStorage.getItem('token');
  const vinculo = JSON.parse(localStorage.getItem('vinculo') || '{}');

  useEffect(() => {
    if (show) {
      if (data) {
        setCodigo(formatarCodigo(data.codigo || ''));
        setDescricao(data.descricao || '');
      } else {
        setCodigo('');
        setDescricao('');
      }
    }
  }, [data, show]);

  const formatarCodigo = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 17);
    const partes = [
      digits.slice(0, 2),
      digits.slice(2, 5),
      digits.slice(5, 9),
      digits.slice(9, 10),
      digits.slice(10, 13),
      digits.slice(13, 17),
    ];
    return partes.filter(p => p).join('.');
  };

  const handleCodigoChange = (e) => {
    const formatted = formatarCodigo(e.target.value);
    setCodigo(formatted);
  };

  const handleSave = async () => {
    if (!codigo || !descricao) return;
    const regex = /^\d{2}\.\d{3}\.\d{4}\.\d\.\d{3}(\.\d{2,4})?$/;
    if (!regex.test(codigo)) {
      return;
    }
    setSaving(true);
    try {
      const codigoLimpo = codigo.replace(/\./g, '');
      const payload = {
        cnpjEntidade: data ? data.cnpjEntidade : vinculo.idEntidade,
        codigo: codigoLimpo,
        descricao,
      };
      if (data) {
        await axios.put(
          `${API_BASE_URL.ACAO_GOVERNAMENTAL}/${data.cnpjEntidade}/${codigoLimpo}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          API_BASE_URL.ACAO_GOVERNAMENTAL,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      if (onSave) onSave();
      if (onClose) onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  const codigoValido = /^\d{2}\.\d{3}\.\d{4}\.\d\.\d{3}(\.\d{2,4})?$/.test(codigo);

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header text-white" style={{
            background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
            padding: '0.5rem 1rem'
          }}>
            <h6 className="modal-title mb-0">
              {data ? 'Editar Ação Governamental' : 'Nova Ação Governamental'}
            </h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={saving} aria-label="Fechar"></button>
          </div>
          <div className="modal-body">
            <div className="mb-2">
              <label className="form-label small fw-semibold">
                Código <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${codigo && !codigoValido ? 'is-invalid' : ''}`}
                placeholder="FF.SSS.PPPP.T.NNN.LLL"
                maxLength={22}
                value={codigo}
                onChange={handleCodigoChange}
                disabled={!!data}
              />
              {codigo && !codigoValido && (
                <div className="invalid-feedback d-block">
                  Formato inválido. Use FF.SSS.PPPP.T.NNN.LLL (localizador opcional)
                </div>
              )}
              {!codigo && (
                <div className="form-text text-muted">
                  <i className="bi bi-info-circle me-1"></i>
                  FF (Função) . SSS (Subfunção) . PPPP (Programa) . T (Tipo) . NNN (Natureza) . LL.. (Localizador, opcional, 2 a 4 dígitos)
                </div>
              )}
            </div>
            <div className="mb-2">
              <label className="form-label small fw-semibold">
                Descrição <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control"
                rows={4}
                value={descricao}
                onChange={e => setDescricao(e.target.value)}
              />
            </div>
          </div>
          <div className="modal-footer py-2">
            <button className="btn btn-secondary btn-sm me-2" onClick={onClose} disabled={saving}>
              Cancelar
            </button>
            <button
              className="btn btn-primary btn-sm"
              onClick={handleSave}
              disabled={saving || !codigoValido || !descricao}
            >
              {saving ? (
                <><span className="spinner-border spinner-border-sm me-1"></span> Salvando...</>
              ) : (
                'Salvar'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AcaoGovernamentalModal;
